import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { GUARANTEED } from '../logic/common/state'
type Refresh = () => void

interface GuaranteeItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingGuaranteeItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmGuarantee: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenGuaranteeModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
  onGuaranteeSuccess?: () => void
}

export const guaranteeItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingGuaranteeItem,
  setNameReserve,
  setHashItemReserve,
  setConfirmGuarantee,
  setOpenGuaranteeModal,
  onGuaranteeSuccess,
}: GuaranteeItemReservationParams): Promise<void> => {
  try {
    setLoadingGuaranteeItem(true)
    setOpenGuaranteeModal && setOpenGuaranteeModal(false)
    const response = await itemServices.update_payment_status_guaranteed(hashItemReserve)
    if (response?.payment_status === GUARANTEED) {
      notify('ra.notification.guarantee_item_success', {
        type: 'success',
        messageArgs: { item: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmGuarantee && setConfirmGuarantee(false)
      setLoadingGuaranteeItem(false)
      onGuaranteeSuccess && onGuaranteeSuccess()
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmGuarantee && setConfirmGuarantee(false)
    setLoadingGuaranteeItem(false)
    notify('ra.notification.guarantee_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.guarantee_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingGuaranteeItem(false)
    setConfirmGuarantee && setConfirmGuarantee(false)
    setOpenGuaranteeModal && setOpenGuaranteeModal(false)
  } finally {
    customAwait([refresh])
  }
}
